import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import { IGetAdminLaundryHolidaysQueryParams } from "types/laundry"

import laundriesService from "api/laundriesService"

const useGetAdminLaundryHolidays = (query: IGetAdminLaundryHolidaysQueryParams, enabled: boolean) => {
  return useQuery(["admin_laundry_holidays", {...query}], async () => {
    try {
      const res: AxiosResponse<any> =
         await laundriesService.getAdminLaundryHolidays(query)
      return res.data
    } catch(err: any) {
      return err.response
    }
  }, { refetchOnWindowFocus: false, enabled })
}

export default useGetAdminLaundryHolidays